export default "__VITE_ASSET__Cy6x7O7F__"